import {
  Guest,
  ReceiveOptions,
} from '@/app/system/guest/Guest';
import { RuntimeError } from '@/shared/lib/core/errors';
import { Pool } from '@/app/system/guest/Pool';

/**
 * Пул постоянных посетителей для источника - патронов
 */
export class PatronPool<T> implements Guest<T>, Pool<T> {
  private patrons = new Set<Guest<T>>();

  public constructor(private initiator: unknown) {}

  /**
   * Добавить гостя в пул патронов, если гость представился патроном
   */
  public add(shouldBePatron: Guest<T>) {
    try {
      if (shouldBePatron.introduction() === 'patron') {
        this.patrons.add(shouldBePatron);
      }
      return this;
    } catch (e) {
      throw new RuntimeError('Cant add patron to pool', { cause: e });
    }
  }

  /**
   * Передать один документ всем известным патронам
   */
  public receive(value: T, options?: ReceiveOptions) {
    this.patrons.forEach(target => {
      target.receive(value, {
        ...options,
        specificData: {
          ...(options?.specificData ?? {}),
          initiator: this.initiator,
        },
      });
    });
    return this;
  }

  public distributeReceivingOnce(receiving: T, possiblePatron: Guest<T>) {
    this.add(possiblePatron);
    possiblePatron.receive(receiving);
  }

  /**
   * ATTENTION! этот метод может быть опасен, если использовать его в
   * местах где нужно данные отдать, может привести к записи старых данных
   *
   * Передаст получение гостю и добавит его в патроны
   * если гость является патроном. Также передаст получение
   * другим уже существовавшим ранее патронам
   */
  public distributeReceiving(receiving: T, ...possiblePatrons: Guest<T>[]) {
    const options: ReceiveOptions = {
      specificData: {
        initiator: this.initiator,
      },
    };
    possiblePatrons.forEach(patron => patron.receive(receiving, options));
    this.receive(receiving, options);
    possiblePatrons.forEach(patron => this.add(patron));
    return this;
  }

  public introduction() {
    return 'guest' as const;
  }
}
